<template>
    <section>
        <users :users="userList" list="inactive"></users>
        <info-box :message="inactive"></info-box>
    </section>
</template>

<script>
import { InformationCircleIcon } from "@heroicons/vue/solid";
import InfoBox from "../../../components/InfoBox.vue";

const inactive =
    "<b>Deelnemers in deze lijst hebben geen toegang (meer) tot de vergaderingen</b><br>Hierdoor is dus de mogelijkheid om deelnemers tijdelijk de toegang te ontzeggen voor een bepaalde periode zonder deze deelnemers uit de lijst te hoeven wissen. Deze deelnemers ontvangen ook geen uitnodigingen meer.";

export default {
    components: {
        InformationCircleIcon,
        InfoBox,
    },
    mounted() {
        this.inactive =
            "<b>" +
            this.t(
                "users.inactive-title",
                "Deelnemers in deze lijst hebben geen toegang (meer) tot de vergaderingen"
            ) +
            "</b><br>" +
            this.t(
                "users.inactive-text",
                "Hierdoor is dus de mogelijkheid om deelnemers tijdelijk de toegang te ontzeggen voor een bepaalde periode zonder deze deelnemers uit de lijst te hoeven wissen. Deze deelnemers ontvangen ook geen uitnodigingen meer."
            );
    },
    created() {},
    props: ["users"],
    data() {
        return {
            inactive,
        };
    },
    computed: {
        userList() {
            var self = this;
            try {
                if (this.users) {
                    return this.users.filter(function (u) {
                        return u.is_blocked;
                    });
                }
            } catch (error) {}
            return this.users;
        },
    },
};
</script>
